import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './components/App'
import { history, store } from './store'
import { Provider } from 'react-redux'
import Actions from './actions'
import LogRocket from 'logrocket'
import { isProduction } from './utils/envUtils'
import LogrocketFuzzySanitizer from 'logrocket-fuzzy-search-sanitizer'
import { HistoryRouter as Router } from 'redux-first-history/rr6'

// STYLES
import './styles/reset-css.css'
import './styles/theme.css'

// FONT ICON
import './resources/fonts/antidote-v1.0/style.css'

const privateFieldNames = ['password', 'token', 'ssn']
const { requestSanitizer, responseSanitizer } =
  LogrocketFuzzySanitizer.setup(privateFieldNames)

if (isProduction) {
  LogRocket.init('zvveep/enrollment-app', {
    network: {
      requestSanitizer,
      responseSanitizer
    }
  })
} else {
  LogRocket.init('zvveep/enrollment-app-qa', {
    network: {
      requestSanitizer,
      responseSanitizer
    }
  })
}

store.dispatch(Actions.createAction(Actions.APP_LAUNCHED))

const root = createRoot(document.getElementById('root'))

// Maintenance Page - Uncomment to enable
// function MaintenancePage() {
//   return (
//     <div
//       className='page'
//       style={{
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'center',
//         padding: '3vw',
//         alignItems: 'center',
//         fontFamily: 'Arial, Helvetica, sans-serif',
//         minHeight: '100vh',
//         backgroundColor: '#f5e3cb'
//       }}
//     >
//       <img
//         alt=''
//         className='img'
//         style={{
//           width: '50%',
//           maxWidth: 500,
//           position: 'relative',
//           left: '3.5vw'
//         }}
//         src='https://storage.googleapis.com/antidote-public-assets/img/notFound1.svg'
//       />
//       <div
//         className='title'
//         style={{
//           fontSize: 50,
//           textTransform: 'uppercase',
//           marginTop: 24,
//           fontWeight: 'bold',
//           textAlign: 'center'
//         }}
//       >
//         Page Not Found
//       </div>
//       <p className='description' style={{ fontSize: 20, textAlign: 'center' }}>
//         Sorry, the page you are looking for does not exist.
//       </p>
//     </div>
//   )
// }

root.render(
  <Provider store={store}>
    <Router history={history}>
      <App />
      {/* To enable maintenance mode, replace <App /> with <MaintenancePage /> */}
    </Router>
  </Provider>
)
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
